/* ==================================================
スムーススクロール
================================================== */
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

/* ==================================================
ヘッダー操作
================================================== */
$(() => {
  // $(window).on("load", () => {
  //   let lastScroll = $(window).scrollTop();
  //   $(window).scroll(() => {
  //     if ($(window).width() > 1040) {
  //       if ($(window).scrollTop() > lastScroll) {
  //         $(".js-header").addClass("closed");
  //       } else {
  //         $(".js-header").removeClass("closed");
  //       }
  //     }
  //     lastScroll = $(window).scrollTop();
  //   });
  // });

  $(".js-headerDropDown").on("click", () => {
    $(".js-headerDrawer").toggleClass("open");
  });

  $(".js-subNavCloseButton").on("click", () => {
    $(".js-headerDrawer").toggleClass("open");
  });

  $('[data-action="open-accordion"]').on("click", (e) => {
    const targetId = $(e.target).data('target');
    $(`#${targetId}`).toggleClass('--open');
    $(e.target).toggleClass('--open');
  });
});

/* ==================================================
スマホ検索ボタン
================================================== */
$(function () {
  $("#search-toggle").click(function () {
    $("body").addClass("searchOpen");
  });
  $(".search-bar__close").click(function () {
    $("body").removeClass("searchOpen");
  });
  $(".drawer-wrap").click(function () {
    $("body").removeClass("searchOpen");
  });
});

/* ==================================================
readmore
================================================== */
$(function () {
  $(".readMore").each(function () {
    $(this).click(function (e) {
      $(this).prev().slideDown("slow");
      $(this).prev().addClass("js-open");
      $(this).addClass("js-open");
    });
  });
});

/* ==================================================
slider
================================================== */
$(document).ready(function () {
  $(".slider").slick({
    autoplay: true,
    fade: true,
    arrows: false,
    dots: true,
  });
});

$(() => {
	$('.mvSlider').slick({
		autoplay: false,
		fade: true,
		arrows: false,
		infinite: true,
		dots: true,
		asNavFor: '.mvSliderNav'
	});

	$('.mvSliderNav').slick({
		autoplay: false,
		fade: false,
		arrows: false,
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		vertical: true,
		infinite: true,
		focusOnSelect: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		asNavFor: '.mvSlider'
	});
});

$(document).ready(function () {
  $(".itemSlider").slick({
    slidesToShow: 4,
    arrows: true,
    dots: false,
    swipeToSlide: true,
    focusOnSelect: false,
    touchMove: true,
    responsive: [
      {
        breakpoint: 768, //767px以下のサイズに適用
        settings: {
          slidesToShow: 2.1,
          arrow: false,
        },
      },
    ],
  });
});

$(() => {
  if ($(window).width() > 1039) {
    $(".productGridItemHoverSlider").slick({
      autoplay: false,
      fade: true,
      arrows: true,
      dots: false,
    });

    $(".productGridItem").on("mouseenter", (e) => {
      const slider = $(e.currentTarget).next();
      slider.addClass("active");
      slider.on("mouseleave", (e) => {
        $(e.currentTarget).removeClass("active");
        $(e.currentTarget).off("mouseleave");
      });
    });
  } else {
    $(".productGridItemSlider").slick({
      autoplay: false,
      fade: true,
      arrows: false,
      dots: true,
    });
  }
});

/* ==================================================
youtube
================================================== */
$(function () {
  $("#js-mainvisualVideo").YTPlayer();
});
/* ==================================================
mypage
================================================== */
$(function () {
  $("#RecoverPassword,#HideRecoverPasswordLink,#login").click(function () {
    $("#CustomerLoginForm,#RecoverPasswordForm").toggleClass("hide");
  });
  $("#submitEmail").click(function () {
    $("#ResetSuccess").toggleClass("hide");
  });
});
$(function () {
  $(".address-edit-toggle").click(function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });
  $(".address-new-toggle").on("click", function () {
    $("#AddressNewForm").toggleClass("hide");
  });
});
/* ==================================================
Loading
================================================== */
$(function () {
  var loading = $(".loading");
  var isHidden = function () {
    loading.fadeOut(800);
  };
  if ($(".bettina").length) {
    setTimeout(function () {
      isHidden();
    }, 1100);
  } else {
    setTimeout(function () {
      $("body").addClass("is-open");
      isHidden();
    }, 400);
  }
});

setTimeout(function () {
  window.scrollTo(0, 0);
}, 1000);
/* ==================================================
Accordion
================================================== */
$(function () {
  const accordion = document.getElementsByClassName("product_tab");

  for (i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener("click", function () {
      this.classList.toggle("open");
    });
  }
});
